import { set as _set } from 'lodash';
import { fetchAuthSession } from 'aws-amplify/auth';

export const fetchWithAuth = async (resource: RequestInfo | URL, options: RequestInit = {}): Promise<Response> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (token !== undefined && token !== '') {
    _set(options, 'headers.Authorization', token);
  }
  return await fetch(resource, options);
};
